export {default} from './NotesWithCheckbox.connect';
